// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__PEZAb","col":"styles_col__2yF-e","fulfillmentStatus":"styles_fulfillmentStatus__gqwxP","emailCol":"styles_emailCol__1xF0h"};